export const LEGACY_COVERAGE_LEVEL_TYPE: string = 'Legacy';
export const FOOTER_GROUP_NAME: string = 'Footer';
export const DEFAULT_FOOTER_VALUE: string = 'X%';
export const DEFAULT_XRAY_EXAM_STATEMENT: string = 'X-rays & Exams have no limitations for usage';
export const MEMBER_DEFINITION_STATEMENT: string = 'A member is someone within the same household who meets the criteria of being a spouse or legal dependent under the age of 26 or an individual with whom you have legal responsibility for.';
export const DISPLAYABLE_MEMBER_LIMIT_MIN: number = 1;
export const DISPLAYABLE_MEMBER_LIMIT_MAX: number = 6;
export const FULL_PRICE_PERCENTAGE: number = 100;
export const SAVINGS_PERCENTAGE_DECIMALS: number = 2;
